<template>
  <div id="app">
    <MainNavigation />
    <router-view />
    <footer class="site-footer">
      <span class="footer-credit">
        Background photo by
        <a href="https://www.instagram.com/haakonheyer/" target="_blank" rel="noopener noreferrer" title="Visit Haakon Heyerdahl-Larsen's Instagram">Haakon Heyerdahl-Larsen</a>
      </span>
    </footer>
    <Analytics />
  </div>
</template>

<script>
import MainNavigation from './components/MainNavigation.vue'
import { Analytics } from '@vercel/analytics/vue'

export default {
  name: 'App',
  components: {
    MainNavigation,
    Analytics
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.site-footer {
  width: 100%;
  padding: 0.5rem 2rem 1.5rem 2rem;
  box-sizing: border-box;
  text-align: right;
  font-size: 0.9em;
  color: #888;
  background: none;
}
.footer-credit a {
  color: #888;
  text-decoration: underline dotted;
}
.footer-credit a:hover {
  color: #2c3e50;
}
</style>
